import { useMemo } from 'react';

import useUser from 'Hooks/useUser';
import { USER_TYPE, USER_ROLE, PERMISSION_ROLES } from 'Constants';

export default function usePermissions() {
  const { data, isLoading } = useUser();
  const type = data?.type;
  const roleId = data?.userRole?.id;
  const canAccessAccountStatements = data?.canAccessAccountStatements;

  return useMemo(() => ({
    type,
    roleId,
    isLoading,
    canAccessAccountStatements,
    isExternalReseller: type === USER_TYPE.EXTERNAL_RESELLER,
    isInternalReseller: type != null && type !== USER_TYPE.EXTERNAL_RESELLER,
    isAdmin: roleId === USER_ROLE.SUPER_ADMIN || roleId === USER_ROLE.RESELLER_ADMIN,
    hasRole: (...roles) => roles.includes(roleId),
    can: permission => (PERMISSION_ROLES[permission] || []).includes(roleId),
  }), [type, roleId, isLoading, canAccessAccountStatements]);
}
